import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from "../../../Services/translation.service";
import { Category } from '../../../models/category';
import { HelperService } from '../../../Services/helper.service';

@Component({
  selector: 'app-homecategories',
  templateUrl: './homecategories.component.html',
  styleUrls: ['./homecategories.component.css']
})
export class HomecategoriesComponent implements OnInit {
  allowedCategories: any = {
    sofia: [9, 26, 14, 200, 113, 16, 10, 24, 177, 20],
    varna: [9, 26, 14, 147, 115, 16, 10, 24, 327, 20],
    plovdiv: [9, 10, 11, 155, 5, 8, 14, 20, 7, 26 ],
    skopje: [9, 26, 14, 200, 113, 16, 10, 24, 177, 20],
    beograd: [9, 26, 14, 200, 113, 16, 10, 24, 177, 20]
  };
  currentCity: string;
  @Input() categories: Category[] = [];
  categoriesStyles: any = {
    1: {
      icon: "ic-moon icon-restaurants",
      color: "#B856DC"
    },
    5: {
      icon: "ic-moon icon-restaurants",
      color: "#8F56DC"
    },
    8: {
      icon: "ic-moon icon-restaurants",
      color: "#EB5466"
    },
    9: {
      icon: "ic-moon icon-restaurants",
      color: ""
    },
    16: {
      icon: "ic-moon icon-clubs",
      color: "background: #B856DC"
    },
    26: {
      icon: "ic-moon icon-taverns",
      color: "background: #EB5466"
    },
    10: {
      icon: "ic-moon icon-bars",
      color: "background: #8F56DC"
    },
    24: {
      icon: "ic-moon icon-beer",
      color: "background: #8F56DC"
    },
    147: {
      icon: "ic-moon icon-clubs",
      color: "background: #EB5466"
    },
    113: {
      icon: "ic-moon icon-wine-tapas",
      color: "background: #D23078"
    },
    14: {
      icon: "ic-moon icon-pizza",
      color: "background: #D23078"
    },
    115: {
      icon: "ic-moon icon-wine-tapas",
      color: "background: #D23078"
    },
    20: {
      icon: "ic-moon icon-bakery",
      color: ""
    },
    327: {
      icon: "ic-moon icon-bar-dinner",
      color: "background: #B856DC"
    },
    177: {
      icon: "ic-moon icon-bar-dinner",
      color: "background: #B856DC"
    },
    155: {
      icon: "ic-moon icon-bar-dinner",
      color: "background: #B856DC"
    },
    200: {
      icon: "ic-moon icon-sushi",
      color: "background: #EB5466"
    }
  };
  categoriesStylesP: object = {
    1: {
      icon: "ic-moon icon-restaurants",
      color: ""
    },
    5: {
      icon: "ic-moon icon-restaurants",
      color: ""
    },
    118: {
      icon: "ic-moon icon-taverns",
      color: ""
    },
    14: {
      icon: "ic-moon icon-restaurants",
      color: ""
    },
    16: {
      icon: "ic-moon icon-clubs",
      color: "background: #B856DC"
    },
    26: {
      icon: "ic-moon icon-taverns",
      color: "background: #D23078"
    },
    10: {
      icon: "ic-moon icon-bars",
      color: "background: #8F56DC"
    },
    9: {
      icon: "ic-moon icon-beer",
      color: "background: #8F56DC"
    },
    147: {
      icon: "ic-moon icon-clubs",
      color: "background: #EB5466"
    },
    11: {
      icon: "ic-moon icon-clubs",
      color: "background: #EB5466"
    },
    113: {
      icon: "ic-moon icon-wine-tapas",
      color: "background: #D23078"
    },
    20: {
      icon: "ic-moon icon-restaurants",
      color: "background: #B856DC"
    },
    8: {
      icon: "ic-moon icon-beer",
      color: "background: #D23078"
    },
    7: {
      icon: "ic-moon icon-pizza",
      color: "background: #D23078"
    },
    115: {
      icon: "ic-moon icon-wine-tapas",
      color: "background: #D23078"
    },
    327: {
      icon: "ic-moon icon-bar-dinner",
      color: "background: #B856DC"
    },
    177: {
      icon: "ic-moon icon-bar-dinner",
      color: "background: #B856DC"
    },
    155: {
      icon: "ic-moon icon-bar-dinner",
      color: "background: #B856DC"
    },
    200: {
      icon: "ic-moon icon-sushi",
      color: "background: #EB5466"
    }
  };
  loaded: boolean = false;

  // Language
  word: any = {};
  language: string = '';

  constructor(
    private helperService: HelperService,
    private translationService: TranslationService
  ) {
    this.word = this.translationService.word;
    this.language = this.translationService.language;
  }

  ngOnInit(): void {
    const city = this.helperService.getCity();
    const validCities = ['sofia', 'varna', 'plovdiv','skopje','beograd'];
    if(validCities.includes(city)) {
      this.categories = this.categories.filter(y => this.allowedCategories[city].includes(y?.id));
      this.currentCity = city;
    }
    this.loaded = true;
  }

  choseColour(n){
    // #EB5466 ,  #B856DC , #D23078, #8F56DC
    let numb = (n+1) % 4;
    let pickedColour;
    switch(numb){
      case 0:
      return '#FE6E5A';
      case 1:
      return '#EB5466';
      case 2:
      return '#B856DC';
      case 3:
      return '#D23078';
      case 4:
      return '#8F56DC';
      default:
        break;
    }

  }
}
